import { VFC } from 'react';
import { Badge, message, Spin } from 'antd';
import { CloseCircleOutlined } from '@ant-design/icons';
import { useMutation } from 'react-query';
import { captureException } from '@sentry/react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Button } from '../../../../../components/Button/Button';
import { FullWidthHeightSpace } from '../../../../../components/Space/FullWidthHeightSpace';
import { theme } from '../../../../../consts/themeBase';
import { getLoraApi } from '../../../../../api/lora';
import { useStore } from '../../../useStore';
import { queryClient } from '../../../../../services/queryClient';
import { QUERY_KEYS } from '../../../../../utils/queryKeys';
import { ContentSensorRegistration as messages } from '../messages';

const loraApi = getLoraApi();

export const ContentSensorRegistration: VFC = () => {
  const { dataSourceId } = useStore();
  const intl = useIntl();
  const { mutate: registerSensor, isLoading } = useMutation(
    ({ devEui }: { devEui: string }) => loraApi.registerDevice(devEui),
    {
      onSuccess: (data, { devEui }) => {
        if (data.status === 'success') {
          message.success(intl.formatMessage(messages.success));
          queryClient.invalidateQueries(QUERY_KEYS.lora.messages.all(devEui));
        } else {
          message.error(intl.formatMessage(messages.error));
        }
      },
      onError: err => {
        console.error(err);
        captureException(err);
        message.error(intl.formatMessage(messages.error));
      },
    },
  );

  const handleRegisterButtonClick = () => {
    if (dataSourceId !== undefined) {
      registerSensor({ devEui: dataSourceId ?? '' });
    }
  };

  return (
    <FullWidthHeightSpace direction="vertical">
      <div className="text-center">
        <CloseCircleOutlined style={{ color: theme.colors.dustRed, fontSize: 100 }} />
      </div>
      <Badge status="error" text={<FormattedMessage {...messages.error} />} />
      <Badge status="success" text={<FormattedMessage {...messages.sensorSuccess} />} />
      <Button
        block
        className="button"
        disabled={isLoading || dataSourceId === undefined}
        onClick={handleRegisterButtonClick}
      >
        {isLoading ? <Spin /> : <FormattedMessage {...messages.registerSensor} />}
      </Button>
    </FullWidthHeightSpace>
  );
};
